import { render } from "./TextArea.vue?vue&type=template&id=7a9fbd56&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "@/assets/styles/components/collections/form/textarea.styl?vue&type=style&index=0&id=7a9fbd56&lang=stylus&scoped=true"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9fbd56"]])

export default __exports__